import type { HTMLAttributes } from 'react';

import React from 'react';

import { classNames } from '../../../utils/class-names';

import styles from './table-cell.module.css';

export type ActionTableCellProps = HTMLAttributes<HTMLTableCellElement>;

export function ActionTableCell({ children, className, ...props }: ActionTableCellProps) {
  return (
    <td className={classNames(className, styles.tableCell)} {...props}>
      <div data-testid="action-wrapper" className={styles.actions}>
        {children}
      </div>
    </td>
  );
}
